/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_favoriteitineraries__deleteerror2 = /** @type {(inputs: {}) => string} */ () => {
	return `Diese Route konnte nicht aus den Favoriten entfernt werden`
};

const en_favoriteitineraries__deleteerror2 = /** @type {(inputs: {}) => string} */ () => {
	return `This route could not be removed from favorites`
};

const es_favoriteitineraries__deleteerror2 = /** @type {(inputs: {}) => string} */ () => {
	return `Esta ruta no ha podido ser eliminada de tus favoritos`
};

const fr_favoriteitineraries__deleteerror2 = /** @type {(inputs: {}) => string} */ () => {
	return `Cet itinéraire n’a pas pu être supprimé des favoris`
};

const it_favoriteitineraries__deleteerror2 = /** @type {(inputs: {}) => string} */ () => {
	return `Non è stato possibile rimuovere questo percorso dai preferiti`
};

const nl_favoriteitineraries__deleteerror2 = /** @type {(inputs: {}) => string} */ () => {
	return `Deze route kon niet worden verwijderd uit je favorieten`
};

const pt_favoriteitineraries__deleteerror2 = /** @type {(inputs: {}) => string} */ () => {
	return `Não foi possível remover esta rota dos seus favoritos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const favoriteitineraries__deleteerror2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.favoriteitineraries__deleteerror2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("favoriteitineraries__deleteerror2", locale)
	if (locale === "de") return de_favoriteitineraries__deleteerror2(inputs)
	if (locale === "en") return en_favoriteitineraries__deleteerror2(inputs)
	if (locale === "es") return es_favoriteitineraries__deleteerror2(inputs)
	if (locale === "fr") return fr_favoriteitineraries__deleteerror2(inputs)
	if (locale === "it") return it_favoriteitineraries__deleteerror2(inputs)
	if (locale === "nl") return nl_favoriteitineraries__deleteerror2(inputs)
	return pt_favoriteitineraries__deleteerror2(inputs)
};
export { favoriteitineraries__deleteerror2 as "favoriteItineraries__deleteError" }